import type { ReactNode } from 'react';

type Gap = 1 | 2 | 3 | 4 | 6;
type Align = 'start' | 'center' | 'end';
type Justify = 'start' | 'center' | 'end' | 'between';

export function Row({
  children,
  gap = 2,
  align = 'center',
  justify = 'start',
  className,
}: {
  children: ReactNode;
  gap?: Gap;
  align?: Align;
  justify?: Justify;
  className?: string;
}) {
  const cls = [
    'ds-row',
    `ds-row--gap-${gap}`,
    `ds-row--align-${align}`,
    `ds-row--justify-${justify}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <div className={cls}>{children}</div>;
}
